import type { BestContentsApiDto } from '__generated__/api/unauth/types.gen';

import { ROUTES } from '@/constants';

import { PREVIEW_SIZE } from '../../constants';
import { formatDateLabel } from '../../utils';
import { SearchContentsCard } from '../SearchContentsCard';
import { SearchContentsCardSkeletonList } from '../SearchContentsCardSkeleton';
import { SectionHeader } from './SectionHeader';

export function BestContentsPreviewSection({
  keyword,
  items,
  totalCount,
  isLoading,
}: {
  keyword: string;
  items: BestContentsApiDto[];
  totalCount: number;
  isLoading: boolean;
}) {
  if (!isLoading && items.length < 1) return null;

  return (
    <section className="flex w-full flex-col">
      <SectionHeader
        title="정책 활용 가이드"
        totalCount={totalCount}
        moreHref={ROUTES.SEARCH.withSearchParams({
          searchParams: { q: keyword || undefined, category: 'policy-info' },
        })}
      />
      {isLoading ? (
        <SearchContentsCardSkeletonList count={PREVIEW_SIZE} />
      ) : (
        <ul className="flex flex-col gap-12 mobile-tablet:gap-0 mobile-tablet:divide-y mobile-tablet:divide-Gray-100">
          {items.map((item) => (
            <li key={item.bestContentsIdIdx ?? item.bestContentsId}>
              <SearchContentsCard
                imageSrc={item.emojiFileUrl || item.fileUrl}
                title={item.title}
                content={item.contentPreview}
                daysAgo={formatDateLabel(item.createAt)}
                link={ROUTES.POLICY_INFO_DETAIL.pathname({
                  idIdx: item.bestContentsIdIdx ?? '',
                })}
              />
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
